var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 8C20 8 20 8 20 8C20 8 20 8 20 8L14 7L11 2C11 1 11 1 11 1C11 1 11 1 11 1C10 1 10 1 10 1C10 1 10 1 10 2L7 7L1 8C1 8 1 8 1 8C1 8 1 8 1 8C1 8 1 8 1 9C1 9 1 9 1 9L5 13L4 19C4 19 4 19 4 19C4 19 4 20 5 20C5 20 5 20 5 20C5 20 5 20 5 20L11 17L16 20C16 20 16 20 16 20C16 20 16 20 16 20C17 20 17 19 17 19C17 19 17 19 17 19L16 13L20 9C20 9 20 9 20 9C20 8 20 8 20 8Z",
    fill: "#FFCA28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 8C20 8 20 8 20 8C20 8 20 8 20 8L14 7L11 2C11 1 11 1 11 1C11 1 11 1 11 1V17L16 20C16 20 16 20 16 20C16 20 16 20 16 20C17 20 17 19 17 19C17 19 17 19 17 19L16 13L20 9C20 9 20 9 20 9C20 8 20 8 20 8Z",
    fill: "#FFB300"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.554f6ed1dfa284f0edd2a2237c80f08a.svg";
export { ForwardRef as ReactComponent };